const DIPLOM = [
    {
        image:"images/diplom1.png"
    },
    {
        image:"images/diplom2.png",
    }
]

export default DIPLOM;
